import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { authInterceptor } from './common/auth.interceptor';
import { apiPrefixInterceptor } from './common/api-prefix.interceptor';
import { NetworkErrorInterceptor } from './common/networkError.interceptor';
import { initalizer } from './common/initalizer';
import { AuthService } from './services/auth.service';
import { provideNzI18n, zh_CN } from 'ng-zorro-antd/i18n';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { LanguageService } from './services/language.service';
import { provideNzIcons } from 'ng-zorro-antd/icon';

import { HomeOutline, WhatsAppOutline, DownOutline, UpOutline, InfoCircleOutline, LogoutOutline, UserOutline, FileTextOutline, LinkOutline, LineChartOutline, CalendarOutline, FieldTimeOutline, ReloadOutline, PlusOutline, StarOutline, MailOutline, LinkedinOutline, PlusCircleOutline, ArrowRightOutline, MessageOutline, SendOutline, ArrowDownOutline, ArrowUpOutline, MinusOutline, SyncOutline, RocketOutline, TeamOutline, ApiOutline, DatabaseOutline, ThunderboltOutline, GlobalOutline, RiseOutline, SafetyCertificateOutline, BulbOutline, CloudServerOutline, SettingOutline, CustomerServiceOutline, WalletOutline, DollarOutline, CreditCardOutline, PhoneOutline, LinkedinFill, CheckSquareOutline, ExportOutline, ArrowLeftOutline, WifiOutline, SmileOutline, FileSyncOutline, EnvironmentOutline, EnvironmentFill, QuestionCircleOutline, PlayCircleFill, UploadOutline, CloseCircleOutline } from '@ant-design/icons-angular/icons';
import { RoutingService } from './services/routing.service';
import { routes } from './app.routes';
import { ThemeService } from './services/theme.service';
import { RuntimeConfigService } from './services/runtime-config.service';

const icons = [
  HomeOutline,
  WhatsAppOutline,
  DownOutline,
  UpOutline,
  InfoCircleOutline,
  LogoutOutline,
  UserOutline,
  FileTextOutline,
  LinkOutline,
  LineChartOutline,
  CalendarOutline,
  CalendarOutline,
  FieldTimeOutline,
  ReloadOutline,
  PlusOutline,
  StarOutline,
  MailOutline,
  LinkedinOutline,
  PlusCircleOutline,
  ArrowRightOutline,
  MessageOutline,
  SendOutline,
  UserOutline,
  ArrowDownOutline,
  ArrowUpOutline,
  MinusOutline,
  SyncOutline,
  RocketOutline,
  TeamOutline,
  ApiOutline,
  DatabaseOutline,
  ThunderboltOutline,
  GlobalOutline,
  RiseOutline,
  SafetyCertificateOutline,
  BulbOutline,
  CloudServerOutline,
  SettingOutline,
  CustomerServiceOutline,
  WalletOutline,
  DollarOutline,
  CreditCardOutline,
  PhoneOutline,
  LinkedinFill,
  CheckSquareOutline,
  ExportOutline,
  ArrowLeftOutline,
  WifiOutline,
  SmileOutline,
  FileSyncOutline,
  SyncOutline,
  EnvironmentOutline,
  EnvironmentFill,
  QuestionCircleOutline,
  PlayCircleFill,
  UploadOutline,
  CloseCircleOutline,
];

function appInitializerFactory(
  router: Router,
  authService: AuthService,
  routingService: RoutingService,
  themeService: ThemeService,
  runtimeConfigService: RuntimeConfigService,
) {
  return () => initalizer(router, authService, routingService, themeService, runtimeConfigService);
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    // provideRouter(routes),
    provideRouter([]),
    {
      provide: LOCALE_ID,
      useFactory: (languageService: LanguageService) => languageService.getCurrentLocale(),
      deps: [LanguageService]
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [Router, AuthService, RoutingService, ThemeService, RuntimeConfigService],
      multi: true
    },
    provideHttpClient(
      withInterceptors([apiPrefixInterceptor, authInterceptor, NetworkErrorInterceptor])
    ),
    importProvidersFrom(
      [
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        }),
        NzModalModule,
        // NzMessageModule
      ]
    ),
    provideNzI18n(zh_CN),
    provideNzIcons(icons)
  ]
};
